import { FILE_TYPES } from '@witmetrics/utils/constants';
import { uploadFileToFileCollection } from '@/utils/files';

export async function uploadDocument(
  practiceId: number,
  fileCollectionId: number,
  selectedFile: File
) {
  const results = await uploadFileToFileCollection(
    selectedFile,
    practiceId,
    fileCollectionId,
    FILE_TYPES.DOCUMENT.id
  );
  return {
    ...results,
    loadedFile: URL.createObjectURL(
      new Blob([results.buffer], { type: selectedFile.type })
    ),
  };
}
